import { EAgentLevel, ESplitAccountType, IPageParam } from '../../../types/common';
import { ESplitDetailOrderStatus } from './splitDetailOrders';

export interface ISplitOrder {
  /** id */
  id: string;
  /** 三方分账编号 */
  thirdOrderNo?: string;
  /** 平台分账编号 */
  orderNo?: string;
  /** 收款方数量 */
  payeeCount: number;
  /** 通道name */
  channelName: string;
  /** 企业Id */
  companyId: number;
  /** 企业名称 */
  companyName: string;
  /** 代理商名称 */
  agentName: string;
  /** 分账金额（元） */
  orderAmount: string;
  /** 支付状态 */
  paymentStatus: EpaymentStatus;
  /** 分账时间 */
  createTime: string;

  /** 分账账户名称 */
  payerAccountName: string;
  /** 分账账户 */
  payerAccountNo: string;
  /** 操作人 */
  operator: string;
  /** 操作人公司 */
  operatorCompany: string;
  /** 实际到账（元） */
  actualReceivedAmount: string;
  /** 分账类型 */
  ruleType: ESplitOrderType;
  
  /** 门店ID */
  storeId: number;
 /** 门店名称 */
  storeName: number;

  /** 更新人 */
  updater: string;
  /** 更新人公司 */
  updaterCompany: string;

  /** 分账备注 */
  memo: string;
  /** 审核状态|0:待审核|1:已同意|2:已拒绝 */
  auditStatus?: EAuditStatus;
}

export interface ISplitOrderParam {
  /** 三方分账编号 */
  thirdOrderNo?: string;
  /** 平台分账编号 */
  orderNo?: string;
  /** 通道id */
  channelId?: string;
  /** 分账类型 */
  type?: ESplitOrderType;
  /** 分账类型 */
  auditStatus?: EAuditStatus;
  /** 分账时间（起） */
  startTime?: string;
  /** 企业名称 */
  companyId?: string;
  /** 代理商名称 */
  agentId?: string;
  /** 分账时间（止） */
  endTime?: string;
  /** 处理状态 */
  paymentStatus?: EpaymentStatus;
  page: number;
  size: number;
  /** 是否是门店订单。默认：false */
  fromStore?: boolean;
}

export interface ISplitSubOrder {
  id: string;
  /** 收款方编 */
  payeeId: string;
  /** 收款方姓名 */
  payeeName: string;
  /** 收款金额 */
  settlementAmount: number;
  /** 处理状态 */
  subOrderStatus: EpaymentStatus;
  /** 收款时间 */
  createTime: string;
}

export interface ISplitOrderInfo {
  id: number;
  /** 分账订单号	*/
  orderNo: string;
  /** 通道id */
  channelId: string;
  /** 分账类型*/
  model: ESplitAccountType;
  /** 通道 name */
  channelName: string;
  /** 拒绝原因 */
  refuseReason: string;
  /** 分账账户 */
  payerAccountNo: string;
  /** 分账账户名称	*/
  payerAccountName: string;
  /** 规则类型,可用值:AMOUNT,RATIO*/
  ruleType: ESplitOrderType;
  /** 订单金额	*/
  orderAmount: number;
  /** 实际到账金额	*/
  actualReceivedAmount: number;
  /** 通道费率 */
  channelServiceRate: number;
  /** 代理商ID	*/
  agentId: number;
  /** 代理商名称	*/
  agentName: string;
  /** 企业ID	*/
  companyId: number;
  /** 企业名称	*/
  companyName: string;
  /** 付款方ID	*/
  payerId: number;
  /** 代理商等级(0特级 1一级 2二级)	*/
  agentLevel: EAgentLevel;
  /** 支付状态(0成功/1失败/2部分失败/3分账中/4待支付)	*/
  paymentStatus: EpaymentStatus;
  /** 付款方连连编号	*/
  payerLianNo: string;
  /** 创建时间	*/
  createTime: string;
  /** 确认时间	*/
  confirmTime: string;
  /** 是否自留	*/
  isStay: boolean;
  /** 备注	*/
  memo: string;
  /** 自留金额	*/
  stayAmount: number;
  /** 资金比例	*/
  stayRate: number;
  /** 操作人 */
  operator: string;
  /** 操作人公司 */
  operatorCompany: string;
  /** 操作人 */
  confirmor: string;
  /** 门店ID */
  storeld: number;
  /** 门店名称 */
  storeName: string;
  /** 更新人 */
  updater: string;
  /** 更新人公司 */
  updaterCompany: string;
  /** 审核状态10:待审核11:已同意l2:已拒绝 */
  auditStatus: string;
  /** 子订单列表 */
  subOrderList: Array<Record<string, any>>;
  /** 收款订单列表 */
  receiptOrderList: Array<Record<string, any>>;
}

export interface ISplitOrderDetail extends Partial<ISplitOrder> {
  /** 通道 */
  channelName: string;
  subOrderList: any[];
}

export enum ESplitOrderType {
  /** 固定金额 */
  FixedAmout = 'AMOUNT',
  /** 固定比例 */
  FixedPercent = 'RATIO',
}

export const splitOrderTypeLabel = {
  [ESplitOrderType.FixedAmout]: '固定金额',
  [ESplitOrderType.FixedPercent]: '固定比例',
};

/** 支付状态 */
export enum EpaymentStatus {
  /** 成功 */
  Succeed = 0,
  /** 失败 */
  Failed = 1,
  /** 部分成功 */
  PartSucceed = 2,
  /** 分账中 */
  Processing = 3,
  /** 待支付 */
  WaitPay = 4,
  /** 已取消 */
  Cancel = 5,
  /** 退汇 */
  Refund = 6,
}

export const paymentStatusLable = {
  [EpaymentStatus.Failed]: '失败',
  [EpaymentStatus.Succeed]: '已完成',
  [EpaymentStatus.PartSucceed]: '部分成功',
  [EpaymentStatus.Processing]: '分账中',
  [EpaymentStatus.WaitPay]: '待支付',
  [EpaymentStatus.Cancel]: '已取消',
  [EpaymentStatus.Refund]: '退汇',
};

export const paymentStatusStyle = {
  [EpaymentStatus.Failed]: 'danger',
  [EpaymentStatus.Refund]: 'danger',
  [EpaymentStatus.Succeed]: 'success',
  [EpaymentStatus.PartSucceed]: 'primary',
  [EpaymentStatus.WaitPay]: 'warning',
  [EpaymentStatus.Cancel]: 'info',
  [EpaymentStatus.Processing]: 'warning',
};

/** 分账复核-分账状态 */
export enum ECompoundOrderStatus {
  /** 支付成功 */
  Succeed = 0,
  /** 支付失败 */
  PayFailed = 1,
  /** 分账中 */
  Splitting = 3,
  /** 待审核 */
  UnderReview = 4,
  /** 支付取消 */
  PayCancel = 5,
}

export const compoundOrderStatusLabel = {
  [ECompoundOrderStatus.Succeed]: '支付成功',
  [ECompoundOrderStatus.PayCancel]: '支付取消',
  [ECompoundOrderStatus.Splitting]: '分账中',
  [ECompoundOrderStatus.UnderReview]: '待审核',
  [ECompoundOrderStatus.PayFailed]: '支付失败',
};

export const compoundOrderStatusStyle = {
  [ECompoundOrderStatus.Succeed]: 'success',
  [ECompoundOrderStatus.PayCancel]: 'info',
  [ECompoundOrderStatus.Splitting]: 'primary',
  [ECompoundOrderStatus.UnderReview]: 'primary',
  [ECompoundOrderStatus.PayFailed]: 'danger',
};

export enum EAuditStatus {
  /** 待审核 */
  PendingApproval = 0,
  /** 已同意 */
  Agreed = 1,
  /** 已拒绝 */
  Rehected = 2,
}

export const auditStatusLabel = {
  [EAuditStatus.PendingApproval]: '待审核',
  [EAuditStatus.Agreed]: '已同意',
  [EAuditStatus.Rehected]: '已拒绝',
};

export const auditStatusStyle = {
  [EAuditStatus.PendingApproval]: 'primary', // 陈双要改的 要是再改回来绝对不认可    2024年12月31日 17:45
  [EAuditStatus.Agreed]: 'success',
  [EAuditStatus.Rehected]: 'danger',
};

export interface ISplitSubOrderItem {
  /** 主订单ID */
  orderId: number;
  /** 主订单号  */
  orderNo: string;
  /** 子订单ID  */
  subOrderId: number;
  /** 子订单号  */
  subOrderNo: string;
  /** 确认时间  */
  confirmTime: string;
  /** 收款方类型 个人-1/企业-2  */
  payeeType: number;
  /** 收款方名称  */
  payeeName: string;
  /** 收款方联系方式  */
  payeeContact: string;
  /** 收款账户银行  */
  payeeAccountBank: string;
  /** 分账账户  */
  payeeAccountNo: string;
  /** 分账金额  */
  settlementAmount: number;
  /** 支付状态(0成功/1失败/3分账中/4待支付/5已取消)  */
  subOrderStatus: ESplitDetailOrderStatus;
  /** 失败原因  */
  failReason: string;
  /** 交易回单地址  */
  txnRcptUrl: string;
  /** 企业ID  */
  companyId: number;
  /** 企业名称  */
  companyName: string;
  /** 代理商ID  */
  agentId: number;
  /** 代理商名称  */
  agentName: string;
  /** 代理商等级  */
  agentLevel: number;
}

export interface ISplitSubOrderParam extends IPageParam {
  /** 主订单号 */
  orderNo?: string;
  /** 子订单号 */
  subOrderNo?: string;
  /** 确认时间（起） */
  confirmTimeStart?: string;
  /** 确认时间（止） */
  confirmTimeEnd?: string;
  /** 是否是门店订单。默认：false */
  fromStore?: boolean;
  /** 企业ID  */
  companyId?: number;
}

export enum EOrderDetailCompoundStatus{
  /** 复核中 */
  APPROVING = 'APPROVING',
  /** 已支付 */
  PAID = 'PAID',
  /** 已取消 */
  CANCELLED = 'CANCELLED',
  /** 冲退 */
  REVERSED = 'REVERSED'
}

export const orderDetailCompoundStatusLabel = {
  [EOrderDetailCompoundStatus.APPROVING]: '待审核',
  [EOrderDetailCompoundStatus.PAID]: '支付成功',
  [EOrderDetailCompoundStatus.CANCELLED]: '支付取消',
  [EOrderDetailCompoundStatus.REVERSED]: '支付失败',
};

export const orderDetailCompoundStatusStyle = {
  [EOrderDetailCompoundStatus.APPROVING]: 'primary',
  [EOrderDetailCompoundStatus.PAID]: 'success',
  [EOrderDetailCompoundStatus.CANCELLED]: 'info',
  [EOrderDetailCompoundStatus.REVERSED]: 'danger',
};